import logo from '../logo.svg';
import { useEffect, useState } from 'react';
import moment from 'moment';
import localforage from 'localforage';

import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';

import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import Loader from '../components/Loader';

const from = moment().add(-30, 'days');
const secondFrom = moment().add(-7, 'days');
const to = moment();

const markets = [
  { name: 'German', id: 19 },
  { name: 'France', id: 14 },
  { name: 'UK', id: 18 },
];

const technologiesVariables = [
  'Other',
  'Fossil%20Oil',
  'Geothermal',
  'Solar',
  'Hydro%20Pumped%20Storage',
  'Fossil%20Gas',
  'Fossil%20Hard%20coal',
  'Fossil%20Brown%20coal%2FLignite',
  'Nuclear',
  'Other%20renewable',
  'Wind%20Onshore',
  'Wind%20Offshore',
  'Hydro%20Water%20Reservoir',
  'Biomass',
];

const technologiesVariablesUk = [
  'BMRS%2FHalf%20Hourly%20Outturn%20Generation%20-%20Other',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Fossil%20Oil',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Geothermal',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Solar',
  'EQ%2FHydro%20Pumped-storage%20Actual',
  'EQ%2FNatural%20Gas%20Actual',
  'EQ%2FHard%20Coal%20Actual',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Fossil%20Brown%20coal%2FLignite',
  'EQ%2FNuclear%20Actual',
  'BMRS%2FInstalled%20Generation%20Capacity%20Aggregated%20-%20Other%20renewable',
  'BMRS%2FHalf%20Hourly%20Outturn%20Generation%20-%20Wind',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Wind%20Offshore',
  'BMRS%2FActual%20Aggregated%20Generation%20-%20Hydro%20Water%20Reservoir',
  'EQ%2FBiomass%20Actual',
];

const technologies = [
  'Other',
  'Fossil Oil',
  'Geothermal',
  'Solar',
  'Hydro Pumped Storage',
  'Gas',
  'Fossil Hard coal',
  'Lignite',
  'Nuclear',
  'Other renewable',
  'Wind Onshore',
  'Wind Offshore',
  'Hydro Water Reservoir',
  'Biomass',
];

const colors = [
  '#fabed4',
  '#ffd8b1',
  '#3cb44b',
  '#8B0000',
  '#4363d8',
  '#aaffc3',
  '#f58231',
  '#dcbeff',
  '#00008B',
  '#a9a9a9',
  '#008000',
  '#42d4f4',
  '#bfef45',
  '#f032e6',
];

function Europe() {
  const stopPeriod = 50;

  const [speedSec, setSpeedSec] = useState({
    1: 3,
    2: 3,
    3: 1,
  });

  const [graphNumber, setGraphNumber] = useState(1);

  const [enableRot, setEnableRot] = useState(true);

  const [dataGe, setDataGe] = useState([]);
  const [dataFr, setDataFr] = useState([]);
  const [dataUk, setDataUk] = useState([]);

  const [imbData, setImbData] = useState([]);

  const [dataGenerationMonth, setDataGenerationMonth] = useState([]);
  const [dataGenerationWeek, setDataGenerationWeek] = useState([]);

  const [dataResidualLoad, setDataResidualLoad] = useState([]);

  const [optionsDa, setOptionsDa] = useState({});
  const [optionsGeneration, setOptionsGeneration] = useState({}); // Options for one graph with three countrees in order
  const [optionsGenerationMarkets, setOptionsGenerationMarkets] = useState([]); // Options for three separate graphs
  const [optionsGenerationMarketsOne, setOptionsGenerationMarketsOne] =
    useState([]); // Options for one graph with three countries in the same time

  const [optionsImbalance, setOptionsImbalance] = useState({});

  const [seconds, setSeconds] = useState(0);
  const [iteration, setIteration] = useState(0);
  const [imbIntervalUpd, setImbIntervalUpd] = useState(0);

  const getDa = async () => {
    let dataGe = await localforage.getItem('dataGeEu');
    let dataFr = await localforage.getItem('dataFrEU');
    let dataUk = await localforage.getItem('dataUkEU');
    let updateDate = localStorage.getItem('dateDataUkEU');
    if (
      !dataGe ||
      !dataFr ||
      !dataUk ||
      updateDate !== moment().format('YYYY-MM-DD')
    ) {
      const urlGe = `https://kube.sama.energy/gateway/api/markets/rich_values/19/EPEX%2F1200-CET%20Hourly%20Day-ahead%20Baseload%20price?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const urlFr = `https://kube.sama.energy/gateway/api/markets/rich_values/14/EPEX%2F1200-CET%20Hourly%20Day-ahead%20Baseload%20price?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const urlUk = `https://kube.sama.energy/gateway/api/markets/rich_values/18/EQ%2FEPEX%200920-WET%20Price%20Spot%20EUR%2FMWh%20Actual?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;

      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      const resGe = await fetch(urlGe, {
        method: 'GET',
        headers: headers,
      });
      const resFr = await fetch(urlFr, {
        method: 'GET',
        headers: headers,
      });
      const resUk = await fetch(urlUk, {
        method: 'GET',
        headers: headers,
      });
      dataGe = await resGe.json();
      dataFr = await resFr.json();
      dataUk = await resUk.json();
      localforage.setItem('dataGeEu', dataGe);
      localforage.setItem('dataFrEu', dataFr);
      localforage.setItem('dataUkEu', dataUk);
      localStorage.setItem('dateDataGeEu', moment().format('YYYY-MM-DD'));
      localStorage.setItem('dateDataFrEu', moment().format('YYYY-MM-DD'));
      localStorage.setItem('dateDataUkEu', moment().format('YYYY-MM-DD'));
    }

    setDataGe(dataGe.data[0]);
    setDataFr(dataFr.data[0]);
    setDataUk(dataUk.data[0]);
  };

  const getResidualLoad = async () => {
    let dataResLoad = await localforage.getItem('dataResidualLoadEu');
    let updateDate = localStorage.getItem('dateResLoadEu');
    if (!dataResLoad?.length || updateDate !== moment().format('YYYY-MM-DD')) {
      const url = (id) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/EQ%2FResidual%20Load%20Actual?start=${from.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };

      const urlMonth = [];
      markets.forEach((market) => {
        urlMonth.push(url(market.id));
      });

      const dataPromiss = urlMonth.map(async (url) => {
        const res = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        return await res.json();
      });
      const data = await Promise.all(dataPromiss);
      dataResLoad = data.map((item) => item.data[0]);

      dataResLoad.updateDate = moment().format('YYYY-MM-DD');
      localforage.setItem('dataResidualLoadEu', dataResLoad);
      localStorage.setItem('dateResLoadEu', moment().format('YYYY-MM-DD'));
    }
    setDataResidualLoad(dataResLoad);
  };

  const getGeneration = async () => {
    let dataGenerationMonthLocal = await localforage.getItem('dataGenerationMonthEu');
    let dataGenerationWeekLocal = await localforage.getItem('dataGenerationWeekEu');
    const updateDate = localStorage.getItem('dateDataGenerationWeekEu');
    if (
      !dataGenerationMonthLocal ||
      !dataGenerationWeekLocal ||
      updateDate !== moment().format('YYYY-MM-DD')
    ) {
      const getGenerationUrlMonth = (id, technology) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/ENTSOE-API-aux%2FActualGenerationOutput%2F${technology}?start=${from.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const getGenerationUrlUkMonth = (id, technology) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/BMRS%2FActual%20Aggregated%20Generation%20-%20${technology}?start=${from.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;

      const getGenerationUrlWeek = (id, technology) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/ENTSOE-API-aux%2FActualGenerationOutput%2F${technology}?start=${secondFrom.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const getGenerationUrlUkWeek = (id, variable) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/${variable}?start=${secondFrom.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const getWindUrlUkWeek = (id) =>
        `https://kube.sama.energy/gateway/api/markets/rich_values/${id}/BMRS%2FHalf%20Hourly%20Outturn%20Generation%20-%20Wind?start=${secondFrom.format(
          'YYYY-MM-DD'
        )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      const urlMonth = [];
      markets.forEach((market) => {
        technologiesVariables.forEach((technology) => {
          urlMonth.push(
            market.id === 18
              ? getGenerationUrlUkMonth(market.id, technology)
              : getGenerationUrlMonth(market.id, technology)
          );
        });
      });

      const urlWeek = [];
      markets.forEach((market) => {
        technologiesVariables.forEach((technology, id) => {
          if (market.id === 18) {
            urlWeek.push(
              getGenerationUrlUkWeek(market.id, technologiesVariablesUk[id])
            );
          } else {
            urlWeek.push(getGenerationUrlWeek(market.id, technology));
          }
        });
      });

      const dataPromiss = urlMonth.map(async (url) => {
        const res = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        if (res.ok) {
          return await res.json();
        } else {
          return { data: [] }
        }
      });
      const dataMonth = await Promise.all(dataPromiss);
      const dataGenerationMonth = dataMonth.map((item) => item.data[0]);
      const dataPromissWeek = urlWeek.map(async (url) => {
        const res = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        if (res.ok) {
          return await res.json();
        } else {
          return { data: [] }
        }
      });
      const dataWeek = await Promise.all(dataPromissWeek);
      const dataGenerationWeek = dataWeek.map((item) => item.data[0]);

      //For Uk windoffshore
      dataGenerationWeek[39] = undefined;
      //
      //change granularity to 1 hour

      const dataGenerationWeekHour = dataGenerationWeek.map((item, id) => {
        if (item) {
          const itemGran = [];
          let gran = 1;
          for (let i = 0; i < item.length - 1; i++) {
            gran = (item[i + 1][0] - item[i][0]) / 3600000;
            if (gran <= 1) {
              break;
            }
          }
          // change data in hour granularity
          for (let i = 0; i < item.length; i += 1 / gran) {
            for (let j = 0; j < 1 / gran; j++) {
              if (j === 0) {
                const idx = Math.floor(i);
                if (item[idx]) {
                  itemGran.push([item[idx][0], item[idx][1]]);
                }
              }
            }
          }
          
          return itemGran;
        } else {
          return item;
        }
      });
      localforage.setItem(
        'dataGenerationMonthEu',
        dataGenerationMonth
      );
      localforage.setItem(
        'dataGenerationWeekEu',
        dataGenerationWeekHour
      );
      localStorage.setItem(
        'dateDataGenerationMonthEu',
        moment().format('YYYY-MM-DD')
      );
      localStorage.setItem(
        'dateDataGenerationWeekEu',
        moment().format('YYYY-MM-DD')
      );
      setDataGenerationMonth(dataGenerationMonth);
      setDataGenerationWeek(dataGenerationWeekHour);
    } else {
      setDataGenerationMonth(dataGenerationMonthLocal);
      setDataGenerationWeek(dataGenerationWeekLocal);
    }
  };

  const getImbData = async (type) => {
    let imbData = await localforage.getItem('dataImbEu');
    const updateDate = localStorage.getItem('dateDataImbEu');

    let published = [];
    let samawatt = [];
    let netz = [];

    if (
      !imbData?.length ||
      type === 'update' ||
      updateDate !== moment().format('YYYY-MM-DD')
    ) {
      const urlPublishedImb = `https://kube.sama.energy/gateway/api/markets/rich_values/19/netztransparenz-ib%2FImbalance%20Price?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const urlSamawattImb = `https://kube.sama.energy/gateway/api/markets/rich_values/19/reconstruction-aux%2FImbalance%20Price?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const urlNetzImb = `https://kube.sama.energy/gateway/api/markets/rich_values/19/netztransparenz-nrv-saldo%2FImbalance%20Price%20Estimate?start=${from.format(
        'YYYY-MM-DD'
      )}T00:00:00&end=${to.format('YYYY-MM-DD')}T00:00:00`;
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };

      try {
        const res = await fetch(urlPublishedImb, {
          method: 'GET',
          headers: headers,
        });

        const data = await res.json();
        published = data.data[0];
        
      } catch (err) {
        console.log(err);
        
      }

      try {
        const res = await fetch(urlSamawattImb, {
          method: 'GET',
          headers: headers,
        });

        const data = await res.json();
        samawatt = data.data[0];
        
      } catch (err) {
        console.log(err);
        
      }

      try {
        const res = await fetch(urlNetzImb, {
          method: 'GET',
          headers: headers,
        });

        const data = await res.json();
        netz = data.data[0];
        
      } catch (err) {
        console.log(err);
      }

      const longestArr = [published, samawatt, netz].reduce((a, b) => a.length > b.length ? a : b);

      const dateObj = {};
      longestArr.forEach((item) => {
        dateObj[item[0]] = { published: null, Samawatt: null, Netz: null };
      });

      published.forEach(el => {
        dateObj[el[0]] = {...dateObj[el[0]], published: el[1]}
      })
      samawatt.forEach(el => {
        dateObj[el[0]] = {...dateObj[el[0]], Samawatt: el[1]}
      })
      netz.forEach(el => {
        dateObj[el[0]] = {...dateObj[el[0]], Netz: el[1]}
      })
      
      imbData = Object.keys(dateObj).map(key => ({ ...dateObj[key], time: Number(key) }));
    
      localforage.setItem('dataImbEu', imbData);
      localStorage.setItem('dateDataImbEu', moment().format('YYYY-MM-DD'));
    }

    let newSumPub = 0.0;
    let newSumDiffSamawatt = 0.0;
    let newSumDiffNetz = 0.0;

    for (let i = 0; i < imbData.length; i += 1) {
      if (typeof imbData[i].published === 'number') {
        newSumPub += Math.abs(imbData[i].published);
      }
      if (
        typeof imbData[i].Samawatt === 'number' &&
        typeof imbData[i].published === 'number'
      ) {
        newSumDiffSamawatt += Math.abs(imbData[i].published - imbData[i].Samawatt);
      }
      if (
        typeof imbData[i].Netz === 'number' &&
        typeof imbData[i].published === 'number'
      ) {
        newSumDiffNetz += Math.abs(imbData[i].published - imbData[i].Netz);
      }
    }

    const newMapeSamawatt = 100.0 * (newSumDiffSamawatt / newSumPub);
    const newMapeNetz = 100.0 * (newSumDiffNetz / newSumPub);
  
    imbData.mapeSamawatt = newMapeSamawatt;
    imbData.mapeNetz = newMapeNetz;
    
    setImbData(imbData);
    
  };

  useEffect(() => {
    if (imbData.length === 0) return;

    const published = [];
    const reconstr = [];
    const sun = [];
    const wind = [];
    const netz = [];
    imbData.forEach((val) => {
      published.push([val.time, val.published]);
      reconstr.push([val.time, val.Samawatt]);
      sun.push([val.time, val.Sun]);
      wind.push([val.time, val.Wind]);
      netz.push([val.time, val.Netz]);
    });

    const diff = moment(published[imbIntervalUpd * 20]?.[0]).diff(
      moment(published[0][0]),
      'days'
    );
    let startImbInd = 0;
    let endImbInd = imbIntervalUpd * 20;

    if (imbIntervalUpd * 20 <= published.length) {
      if (diff > 5 && diff < 30) {
        startImbInd = (imbIntervalUpd - 11) * 20;
        endImbInd = imbIntervalUpd * 20;
      } else if (diff > 30 && diff < 60) {
        startImbInd = (imbIntervalUpd - 31) * 20;
        endImbInd = imbIntervalUpd * 20;
      } else if (diff > 60) {
        startImbInd = (imbIntervalUpd - 61) * 20;
        endImbInd = imbIntervalUpd * 20;
      }
    } else if (imbIntervalUpd * 20 > published.length) {
      startImbInd = 0;
      endImbInd = published.length;
    }

    const serieses = [
      {
        name: 'Actual',
        data: published.slice(startImbInd, endImbInd),
        color: 'black',
      },
      {
        name: `SAMAWATT estimation <br>MAPE: ${imbData.mapeSamawatt.toFixed(
          2
        )}%`,
        data: reconstr.slice(startImbInd, endImbInd),
        color: 'red',
      },
      // {
      //   name: `Provider 1 estimation <br>MAPE: ${imbData.mapeSun.toFixed(2)}%`,
      //   data: sun.slice(startImbInd, endImbInd),
      //   color: '#2e6c33',
      // },
      // {
      //   name: `Provider 2 estimation <br>MAPE: ${imbData.mapeWind.toFixed(2)}%`,
      //   data: wind.slice(startImbInd, endImbInd),
      //   color: '#9ad49f',
      // },
      {
        name: `Netztransparenz estimation <br>MAPE: ${imbData.mapeNetz.toFixed(
          2
        )}%`,
        data: netz.slice(startImbInd, endImbInd),
        color: 'blue',
      },
    ];

    const newOptionsImb = {
      ...baseOptions,
      chart: {
        ...baseOptions.chart,
      },
      tooltip: {
        crosshairs: true,
        borderColor: '#2c3e50',
        shared: true,
        formatter: function (tooltip) {
          const points = this.points;
          return tooltip.bodyFormatter(points).join('');
        },
      },
      title: {
        useHTML: true,
        text: '<img src="https://optimalwindmonitor.sama.energy/static/media/color_logo.17195cbe.png"  width="50" height="50" style="vertical-align: middle;"/> <span style="color:#2b328f;">SAMA<span style="color:red;">Asset<sup style="font-size: 9px;">TM</sup></span></span> <span style="vertical-align: middle;">German Imbalance Price Estimation</span>',
        style: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '30px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
          fontFamily: 'Marcellus, serif',
        },
      },
      xAxis: {
        ...baseOptions.xAxis,
        gridLineWidth: 1,
      },
      yAxis: {
        title: {
          text: 'Imbalance price, EUR/MWh',
          style: {
            color: '#333333',
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis',
          },
        },
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
        },
      },
      legend: {
        itemStyle: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '20px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
        },
      },
      series: serieses,
    };
    setOptionsImbalance(newOptionsImb);
  }, [imbIntervalUpd, imbData]);

  useEffect(() => {
    const speedSec = JSON.parse(localStorage.getItem('speedSecEu'));
    if (speedSec) {
      setSpeedSec(speedSec);
    }
    getDa();
    getGeneration();
    getImbData();
    getResidualLoad();
  }, []);

  const calcMinMaxValue = (array) => {
    const min = Math.min.apply(null, array);
    const max = Math.max.apply(null, array);
    return -min >= max ? -min : max;
  };

  useEffect(() => {
    if (
      dataGe.length === 0 ||
      dataFr.length === 0 ||
      dataUk.length === 0 ||
      dataGenerationMonth.length === 0
    )
      return;

    //array of generations for each market
    const serieseNames = [];
    markets.forEach((market) => {
      technologies.forEach((technology) => {
        serieseNames.push(`${technology}`);
      });
    });

    // const marketsSumGet = [];
    // const marketsSumGetRenewable = [];
    // markets.forEach((market, marketId) => {
    //   const curMarketGeneration = dataGenerationMonth.slice(
    //     marketId * technologies.length,
    //     (marketId + 1) * technologies.length
    //   );
    //   //calculate sum of generation dayli
    //   const dayliGeneration = [];

    //   curMarketGeneration.forEach((genTech) => {
    //     const daylyTechGen = [];
    //     genTech?.forEach((generation, idGen) => {
    //       const day = moment(generation[0]).utc().format('YYYY-MM-DD');
    //       if (idGen === 0) daylyTechGen.push([generation[0], generation[1]]);
    //       else {
    //         const prevDay = moment(genTech[idGen - 1][0])
    //           .utc()
    //           .format('YYYY-MM-DD');
    //         if (day === prevDay) {
    //           daylyTechGen[daylyTechGen.length - 1][1] += generation[1];
    //         } else {
    //           daylyTechGen.push([generation[0], generation[1]]);
    //         }
    //       }
    //     });
    //     dayliGeneration.push(daylyTechGen);
    //   });
    //   const dayliSummeryGeneration = [];
    //   const dayliSummeryGenerationRenewable = [];
    //   const findIndexNotEmpty = dayliGeneration.findIndex(
    //     (item) => item.length > 0
    //   );
    //   dayliGeneration[findIndexNotEmpty].forEach((generation) => {
    //     let sumDayGen = 0;
    //     let sumDayGenRenewable = 0; // Only for Solar, Wind
    //     const timeStamp = generation[0];
    //     dayliGeneration.forEach((generationTech, id) => {
    //       const gen = generationTech.find((item) => item[0] === timeStamp);
    //       if (gen) {
    //         sumDayGen += gen[1];
    //       }
    //       if (gen && [3, 10, 11].includes(id)) sumDayGenRenewable += gen[1];
    //     });
    //     dayliSummeryGeneration.push([timeStamp, sumDayGen]);
    //     dayliSummeryGenerationRenewable.push([timeStamp, sumDayGenRenewable]);
    //   });
    //   marketsSumGet.push(dayliSummeryGeneration);
    //   marketsSumGetRenewable.push(dayliSummeryGenerationRenewable);
    // });

    // Calculate dataResidualLoad for each market day granularity
    // in dataResidualLoad we have data for each hour
    // calculate data for each day
    const dayliMarketResidualLoad = [];
    dataResidualLoad.forEach((market) => {
      const dayliMarket = [];
      market.forEach((item, id) => {
        const day = moment(item[0]).utc().format('YYYY-MM-DD');
        if (id === 0) {
          dayliMarket.push([item[0], item[1]]);
        } else {
          const prevDay = moment(market[id - 1][0])
            .utc()
            .format('YYYY-MM-DD');
          if (day === prevDay) {
            dayliMarket[dayliMarket.length - 1][1] += item[1];
          } else {
            dayliMarket.push([item[0], item[1]]);
          }
        }
      });
      dayliMarketResidualLoad.push(dayliMarket);
    });

    // in dataResidualLoad should be 30 days of data
    // if not than set 0 values for the rest of days
    dayliMarketResidualLoad.forEach((market,id_mar) => {
      if(dayliMarketResidualLoad.length < 30){
        const difMarketEmptyDays = [];
        market.forEach((item, id) => {
          const day = moment(item[0]).utc().format('YYYY-MM-DD');
          if(id != 0) {
            const prevDay = moment(market[id - 1][0])
              .utc()
              .format('YYYY-MM-DD');
            // if difference between days is more than 1 day
            const dif = moment(day).diff(moment(prevDay), 'days')
            if (dif > 1){
              let curEmptyDay = market[id - 1][0];
              for(let i = 1; i < dif; i++) {
                difMarketEmptyDays.push(curEmptyDay + 86400000)
                curEmptyDay += 86400000;
              }
            }
          }
        });
        difMarketEmptyDays.forEach((emptyDay) => {
          // add zero value for empty day
          dayliMarketResidualLoad[id_mar].push([emptyDay, 0]);
        });
        // sort array by date
        dayliMarketResidualLoad[id_mar].sort((a, b) => {
          return a[0] - b[0]; 
        });
      }
    });
    
    // if time in the timestamp is not 00:00:00 set to it
    dayliMarketResidualLoad.forEach((market,id_mar) => {
      market.forEach((item, id) => {
        const day = moment(item[0]).utc().format('YYYY-MM-DD');
        const hour = moment(item[0]).utc().format('HH:mm:ss');
        if(hour !== '00:00:00') {
          dayliMarketResidualLoad[id_mar][id][0] = moment(day + ' 00:00:00').valueOf();
        }
      });
    });
    
    //===================================================================================================

    // Take dayliMarketResidualLoad and calculate each in percents
    const dayliMarketResidualLoadSumMarkets = [];
    if (dayliMarketResidualLoad.length) {
      for (let i = 0; i < dayliMarketResidualLoad[0].length; i++) {
        let sum = 0;
        dayliMarketResidualLoad.forEach((value) => {
          sum += value[i][1];
        });
        const timeStamp = dayliMarketResidualLoad[0][i][0];
        dayliMarketResidualLoadSumMarkets.push([timeStamp, sum]);
      }
    }
    const dayliMarketResidualLoadPercents = [];
    dayliMarketResidualLoad.forEach((market) => {
      const marketArr = [];
      market.forEach((val, id) => {
        const percents =
          (val[1] * 100) / dayliMarketResidualLoadSumMarkets[id][1];
        marketArr.push([val[0], Number(percents.toFixed(2))]);
      });
      dayliMarketResidualLoadPercents.push(marketArr);
    });
    //Calculate UK day ahead data with day granularity
    const dayliUkData = [];
    dataUk.forEach((item, id) => {
      const day = moment(item[0]).utc().format('YYYY-MM-DD');
      if (id === 0) {
        dayliUkData.push([item[0], item[1]]);
      } else {
        const prevDay = moment(dataUk[id - 1][0])
          .utc()
          .format('YYYY-MM-DD');
        if (day === prevDay) {
          dayliUkData[dayliUkData.length - 1][1] += item[1];
        } else {
          dayliUkData.push([item[0], item[1]]);
        }
      }
    });
    dayliUkData.forEach((item) => {
      const value = item[1] / 24;
      item[1] = Number(value.toFixed(2));
    });

    //===================================================================================================

    const valuesGe = dataGe.map((item) => Number(item[1].toFixed(2)));
    const valuesFr = dataFr.map((item) => Number(item[1].toFixed(2)));
    const valuesUk = dayliUkData.map((item) => Number(item[1]));

    const minXGe = Math.min(...valuesGe) > 0 ? 0 : Math.min(...valuesGe);
    const maxXGe = Math.max(...valuesGe) < 0 ? 0 : Math.max(...valuesGe);
    const minXFr = Math.min(...valuesFr) > 0 ? 0 : Math.min(...valuesFr);
    const maxXFr = Math.max(...valuesFr) < 0 ? 0 : Math.max(...valuesFr);
    const minXUk = Math.min(...valuesUk) > 0 ? 0 : Math.min(...valuesUk);
    const maxXUk = Math.max(...valuesUk) < 0 ? 0 : Math.max(...valuesUk);
    const minX = Math.min(minXGe, minXFr, minXUk);
    const maxX = Math.max(maxXGe, maxXFr, maxXUk);
    const maxInitTimeStamp = Math.max(
      dataGe[0][0],
      dataFr[0][0],
      dayliUkData[0][0]
    );
    const initIdGe = dataGe.findIndex((item) => item[0] === maxInitTimeStamp);
    const initIdFr = dataFr.findIndex((item) => item[0] === maxInitTimeStamp);
    const initIdUk = dayliUkData.findIndex(
      (item) => item[0] === maxInitTimeStamp
    );

    const seriesDa = [
      {
        name: 'Germany',
        data: dataGe.slice(initIdGe, seconds + initIdGe),
        type: 'line',
        yAxis: 0,
        color: '#8B0000',
        stacking: null,
      },
      {
        name: 'France',
        data: dataFr.slice(initIdFr, seconds + initIdFr),
        type: 'line',
        yAxis: 0,
        color: '#00008B',
        stacking: null,
      },
      {
        name: 'UK',
        data: dayliUkData.slice(initIdUk, seconds + initIdUk),
        tipe: 'line',
        yAxis: 0,
        color: '#008000',
        stacking: null,
      },
      {
        name: 'German Residual Load',
        data: dayliMarketResidualLoadPercents[0].slice(
          initIdGe,
          seconds + initIdGe
        ),
        type: 'column',
        yAxis: 1,
        color: '#8B0000',
        showInLegend: false,
      },
      {
        name: 'France Residual Load',
        data: dayliMarketResidualLoadPercents[1].slice(
          initIdFr,
          seconds + initIdFr
        ),
        type: 'column',
        yAxis: 1,
        color: '#00008B',
        showInLegend: false,
      },
      {
        name: 'UK Residual Load',
        data: dayliMarketResidualLoadPercents[2].slice(
          initIdUk,
          seconds + initIdUk
        ),
        type: 'column',
        yAxis: 1,
        color: '#008000',
        showInLegend: false,
      },
    ];

    const newOptionsDa = {
      ...baseOptions,
      chart: {
        ...baseOptions.chart,
        marginTop: window.innerHeight / (window.innerHeight === window.screen.height ? 1.8 : 2), // Добавляем верхний отступ
        marginBottom: 40, // Добавляем нижний отступ
        animation: false,
      },
      tooltip: {
        crosshairs: true,
        borderColor: '#2c3e50',
        shared: true,
        formatter: function (tooltip) {
          const points = this.points;
          return tooltip.bodyFormatter(points).join('');
        },
      },
      title: {
        useHTML: true,
        text: '<img src="https://optimalwindmonitor.sama.energy/static/media/color_logo.17195cbe.png"  width="50" height="50" style="vertical-align: middle;"/> <span style="color:#2b328f;">SAMA<span style="color:red;">Asset<sup style="font-size: 9px;">TM</sup></span></span> <span style="vertical-align: middle;">Impact of Residual Load on the Dynamics of Day-Ahead Prices</span>',
        style: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '30px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
          align: 'center',
          fontFamily: 'Marcellus, serif',
        },
      },
      xAxis: {
        ...baseOptions.xAxis,
        min: dataGe[0][0],
        max: dataGe[dataGe.length - 1][0],
      },
      yAxis: [
        {
          title: {
            text: 'DA price, EUR/MWh',
            style: {
              color: '#333333',
              cursor: 'pointer',
              fontSize: '20px',
              fontWeight: 'bold',
              textOverflow: 'ellipsis',
            },
          },
          min: minX,
          max: maxX,
          top: '-110%',
          gridLineWidth: 1,
        },
        {
          title: {
            text: 'Residual Load, %',
            style: {
              color: '#333333',
              cursor: 'pointer',
              fontSize: '20px',
              fontWeight: 'bold',
              textOverflow: 'ellipsis',
            },
          },
          min: 0,
          max: 100,
          offset: 0,
          gridLineWidth: 1,
        },
      ],
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
          stacking: 'normal',
          animation: false,
        },
      },
      legend: {
        itemStyle: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '20px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
        },
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemMarginTop: 10,
        itemMarginBottom: 10,
      },
      series: seriesDa,
    };

    setOptionsDa(newOptionsDa);
  }, [seconds, dataGe, dataFr, dataUk, dataGenerationMonth]);

  useEffect(() => {
    if (dataGenerationWeek.length === 0) return;
    //-----------------------------------------------------------------------------------
    let genArrayLength = [];
    dataGenerationWeek.forEach((item, id) => {
      if (item) {
        genArrayLength.push(item.length);
      }
    });
    let maxGenArrayLength = Math.max(...genArrayLength);
    const exampleMaxLenGenInd = genArrayLength.findIndex(
      (item) => item === maxGenArrayLength
    );
    const firstTs = dataGenerationWeek[exampleMaxLenGenInd][0][0];
    const lastTs =
      dataGenerationWeek[exampleMaxLenGenInd][
        dataGenerationWeek[exampleMaxLenGenInd].length - 1
      ][0];

    // full dataGenerationWeek in each generation array with missing data
    // if there is no data for some hour, we add it with 0 value
    const newDataGenerationWeek = [];
    dataGenerationWeek.forEach((item, id) => {
      if (item) {
        if (item.length <= maxGenArrayLength) {
          let ts = firstTs;
          const newItem = [];
          while (ts < lastTs) {
            const dataPointIndex = item.findIndex((val) => val[0] === ts);
            if (dataPointIndex === -1) {
              newItem.push([ts, 0]);
            } else {
              newItem.push(item[dataPointIndex]);
            }
            ts += 3600000;
          }
          newDataGenerationWeek.push(newItem);
        } else {
          newDataGenerationWeek.push(item);
        }
      } else {
        newDataGenerationWeek.push(null);
      }
    });

    const serieseNames = [];
    markets.forEach((market) => {
      technologies.forEach((technology) => {
        serieseNames.push(`${market.name}:${technology}`);
      });
    });

    //-------------------------------Generate Options for three separate graphs
    const techCount = technologies.length;
    const marketDataSerieses = [];
    const firstMarketData = newDataGenerationWeek.slice(0, iteration + 1);
    markets.forEach((val, id) => {
      const data = newDataGenerationWeek.slice(
        id * techCount,
        id * techCount + iteration + 1
      );
      const names = serieseNames.slice(
        id * techCount,
        id * techCount + iteration + 1
      );
      const series = data.map((val, id) => {
        const name = names[id].split(':');
        return {
          name: name[1],
          data: data[id],
          color: colors[id],
        };
      });
      marketDataSerieses.push(series);
    });

    const newOptionsBase = {
      ...baseOptions,
      xAxis: {
        ...baseOptions.xAxis,
      },
      chart: {
        ...baseOptions.chart,
        type: 'area',
        height: '300',
      },
      yAxis: {
        title: {
          text: 'Generation, MW',
        },
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
        },
        area: {
          stacking: 'normal',
          lineColor: '#666666',
          lineWidth: 1,
          marker: {
            lineWidth: 1,
            lineColor: '#666666',
          },
        },
      },
    };

    const marketsOptions = marketDataSerieses.map((val, id) => {
      const marketName = markets[id]['name'];
      return {
        ...newOptionsBase,
        series: val,
        title: {
          text: `${marketName} Generation`,
        },
      };
    });

    const newOptionsBaseOneGraph = {
      ...baseOptions,
      xAxis: {
        ...baseOptions.xAxis,
      },
      chart: {
        ...baseOptions.chart,
        type: 'area',
        marginTop: 250,
        marginBottom: 120,
      },
      title: {
        text: '',
      },
      yAxis: [
        {
          title: {
            text: 'German Generation, MW',
          },
          top: '-50%',
          height: 200,
        },
        {
          title: {
            text: 'France Generation, MW',
          },
          top: '50%',
          height: 200,
        },
        {
          title: {
            text: 'British Generation, MW',
          },
          height: 200,
          opposite: true,
        },
      ],
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
        },
        area: {
          stacking: 'normal',
          lineColor: '#666666',
          lineWidth: 1,
          marker: {
            lineWidth: 1,
            lineColor: '#666666',
          },
        },
      },
    };

    const marketDataSeriesesOne = [];
    marketDataSerieses.forEach((marketData, id) => {
      marketData.forEach((val) => {
        if (id === 0)
          marketDataSeriesesOne.push({
            name: val.name,
            data: val.data,
            color: val.color,
            yAxis: id,
          });
        else
          marketDataSeriesesOne.push({
            data: val.data,
            color: val.color,
            yAxis: id,
            showInLegend: false,
          });
      });
    });

    const marketsOptionsOne = {
      ...newOptionsBaseOneGraph,
      series: marketDataSeriesesOne,
    };

    setOptionsGenerationMarketsOne(marketsOptionsOne);

    //----------------------------Generate Options for one graph with three countrees in order

    let iter;

    if (iteration < technologies.length) {
      iter = iteration;
    } else if (
      iteration >= technologies.length - 1 &&
      iteration <
        technologies.length + (1 / speedSec[graphNumber]) * (stopPeriod / 2)
    ) {
      iter = technologies.length - 1;
    } else if (
      iteration >=
        technologies.length + (1 / speedSec[graphNumber]) * (stopPeriod / 2) &&
      iteration <
        technologies.length * 2 + (1 / speedSec[graphNumber]) * (stopPeriod / 2)
    ) {
      iter = iteration - (1 / speedSec[graphNumber]) * (stopPeriod / 2);
    } else if (
      iteration >=
        technologies.length * 2 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) &&
      iteration <
        technologies.length * 2 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 2
    ) {
      iter = technologies.length * 2 - 1;
    } else if (
      iteration >=
        technologies.length * 2 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 2 &&
      iteration <
        technologies.length * 3 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 2
    ) {
      iter = iteration - (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 2;
    } else if (
      iteration >=
        technologies.length * 2 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 2 &&
      iteration <
        technologies.length * 3 +
          (1 / speedSec[graphNumber]) * (stopPeriod / 2) * 3
    ) {
      iter = technologies.length * 3 - 1;
    }

    const curIterNames = serieseNames
      .slice(
        Math.floor(iter / technologies.length) * technologies.length,
        iter + 1
      )
      .map((name, id) => {
        const techName = name.split(':')[1];
        return `${techName}`;
      });
    const curIterMarketName = serieseNames
      .slice(
        Math.floor(iter / technologies.length) * technologies.length,
        iter + 1
      )
      .map((name, id) => {
        const marketName = name.split(':')[0];
        return `${marketName}`;
      });

    const curIterGeneration = newDataGenerationWeek.slice(
      Math.floor(iter / technologies.length) * technologies.length,
      iter + 1
    );

    const namesValidGenerations = [];
    curIterGeneration.forEach((generation, id) => {
      if (generation) {
        if (
          curIterMarketName[0] === 'UK' &&
          curIterNames[id] === 'Wind Onshore'
        )
          namesValidGenerations.push('Wind');
        else namesValidGenerations.push(curIterNames[id]);
      }
    });

    const colorsValidGenerations = [];
    curIterGeneration.forEach((generation, id) => {
      if (generation) {
        colorsValidGenerations.push(colors[id]);
      }
    });

    const existGeneration = curIterGeneration.filter(
      (generation) => generation
    );

    const values = existGeneration.map((generation) => {
      const value = generation.map((item) => Number(item[1]));
      return value;
    });
    const sumValues = [];
    values.forEach((value) => {
      value.forEach((item, id) => {
        if (!sumValues[id]) sumValues[id] = 0;
        sumValues[id] += item;
      });
    });

    const firstTimeStamp = existGeneration.map(
      (generation) => generation[0][0]
    );
    const maxInitTimeStamp = Math.max(...firstTimeStamp);
    const initId = existGeneration.map((generation) =>
      generation.findIndex((item) => item[0] === maxInitTimeStamp)
    );

    const serieses = existGeneration.map((item, id) => {
      return {
        name: namesValidGenerations[id],
        data: item,
        color: colorsValidGenerations[id],
      };
    });

    const newOptions = {
      ...baseOptions,
      title: {
        useHTML: true,
        text: `<img src="https://optimalwindmonitor.sama.energy/static/media/color_logo.17195cbe.png"  width="50" height="50" style="vertical-align: middle;"/> <span style="color:#2b328f;">SAMA<span style="color:red;">Asset<sup style="font-size: 9px;">TM</sup></span></span> <span style="vertical-align: middle;"> ${curIterMarketName[0]} Generation Stack</span>`,
        style: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '30px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
          fontFamily: 'Marcellus, serif',
        },
      },
      xAxis: {
        ...baseOptions.xAxis,
        gridLineWidth: 1,
      },
      chart: {
        ...baseOptions.chart,
        type: 'area',
      },
      tooltip: {
        crosshairs: true,
        borderColor: '#2c3e50',
        shared: true,
        formatter: function (tooltip) {
          const points = this.points;
          return tooltip.bodyFormatter(points).join('');
        },
      },
      yAxis: {
        title: {
          text: 'Generation, MW',
          style: {
            color: '#333333',
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis',
          },
        },
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
          connectNulls: true,
        },
        area: {
          stacking: 'normal',
          lineColor: '#666666',
          lineWidth: 1,
          marker: {
            lineWidth: 1,
            lineColor: '#666666',
          },
        },
      },
      legend: {
        itemStyle: {
          color: '#333333',
          cursor: 'pointer',
          fontSize: '20px',
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
        },
      },
      series: serieses,
    };

    setOptionsGeneration(newOptions);
    setOptionsGenerationMarkets(marketsOptions);
  }, [iteration, dataGenerationWeek]);
  
  const baseOptions = {
    xAxis: {
      ordinal: false,
      type: 'datetime',
      dateTimeLabelFormats: {
        // Define how different time units are formatted
        day: '%e %b %y', // e.g., "1 Jan 2020"
        week: '%e %b %y',
        month: "%b '%y", // e.g., "Jan '20"
        year: '%y', // e.g., "2020"
      },
    },
    rangeSelector: {
      enabled: false,
    },
    chart: {
      animation: true,
      height: window.innerHeight === window.screen.height  
        ? window.innerHeight 
        : window.innerHeight - 90
    },
    credits: {
      enabled: false,
    },
  };

  //change the graph to the next one
  useEffect(() => {
    if (enableRot) {
      if (
        seconds >
          dataGe.length + (1 / speedSec[graphNumber]) * stopPeriod - 2 &&
        graphNumber === 1
      ) {
        setGraphNumber((graphNumber) => graphNumber + 1);
        setIteration(0);
      }

      if (
        iteration >
          markets.length * technologies.length -
            1 +
            (1 / speedSec[graphNumber]) * ((stopPeriod / 2) * 3) -
            2 &&
        graphNumber === 2
      ) {
        //change the graph to the next one
        setGraphNumber((graphNumber) => graphNumber + 1);
        setImbIntervalUpd(0);
      }
      if (
        imbIntervalUpd * 20 >
          imbData.length +
            20 * ((1 / speedSec[graphNumber]) * stopPeriod) -
            1 &&
        graphNumber === 3
      ) {
        //change the graph to the next one
        setGraphNumber(1);
        setSeconds(0);
      }
    }
  }, [seconds, iteration, imbIntervalUpd, graphNumber]);

  // set graph itteration 0 when graphNumber is changed
  useEffect(() => {
    if (graphNumber === 1) {
      setSeconds(0);
    }
    if (graphNumber === 2) {
      setIteration(0);
    }
    if (graphNumber === 3) {
      setImbIntervalUpd(0);
    }
  }, [graphNumber]);

  useEffect(() => {}, [iteration, graphNumber]);

  useEffect(() => {
    const intervalTimer = setInterval(() => {
      if (dataGe.length === 0 && dataFr.length === 0 && dataUk.length === 0)
        return;
      const sec = seconds < dataGe.length ? seconds + 1 : 0;
      const maxInitTimeStamp = Math.max(
        dataGe[0][0],
        dataFr[0][0],
        dataUk[0][0]
      );
      const initIdGe = dataGe.findIndex((item) => item[0] === maxInitTimeStamp);
      const initIdFr = dataFr.findIndex((item) => item[0] === maxInitTimeStamp);
      const initIdUk = dataUk.findIndex((item) => item[0] === maxInitTimeStamp);
      setSeconds((seconds) =>
        seconds + initIdGe <
        dataGe.length + (1 / speedSec[graphNumber]) * stopPeriod
          ? seconds + 1
          : 0
      );
    }, 200 * speedSec[graphNumber]);

    const intervalIterationTimer = setInterval(() => {
      setIteration((iter) => {
        if (
          iter <
          markets.length * technologies.length -
            1 +
            (1 / speedSec[graphNumber]) * ((stopPeriod / 2) * 3)
        )
          return iter + 1;
        else return 0;
      });
    }, 200 * speedSec[graphNumber]);

    const imbIntervalUpdTimer = setInterval(() => {
      const imbDataCount = imbData.length;
      setImbIntervalUpd((iter) => {
        // Stay full graph for 10 seconds
        if (
          iter * 20 <= imbDataCount ||
          (iter * 20 > imbDataCount &&
            iter * 20 <
              imbDataCount + 20 * ((1 / speedSec[graphNumber]) * stopPeriod))
        )
          return iter + 1;
        else return 0;
      });
    }, 200 * speedSec[graphNumber]);
    return () => {
      clearInterval(intervalTimer);
      clearInterval(intervalIterationTimer);
      clearInterval(imbIntervalUpdTimer);
    };
  }, [dataGe, dataFr, dataUk, graphNumber, speedSec, graphNumber, speedSec]);

  return (
    <div className="App">
      <div id="chart">
        <div>
          <div
            style={{
              border: '2px dotted #006f1e',
              margin: '5px',
              padding: '5px',
            }}
          > 
            {!dataGenerationMonth.length && graphNumber === 1 ? (
              <Loader />
            ) : dataGenerationMonth.length && graphNumber === 1 ? (
              <HighchartsReact highcharts={Highcharts} options={optionsDa} />
            ) : (
              <></>
            )}
            {!Object.keys(optionsGeneration).length && graphNumber === 2 ? (
              <Loader />
            ) : Object.keys(optionsGeneration).length && graphNumber === 2 ? (
              <HighchartsReact
                highcharts={Highcharts}
                options={optionsGeneration}
              />
            ) : (
              <></>
            )}
            {!Object.keys(optionsImbalance).length && graphNumber === 3 ? (
              <Loader />
            ) : Object.keys(optionsImbalance).length && graphNumber === 3 ? (
              <HighchartsReact
                highcharts={Highcharts}
                options={optionsImbalance}
              />
            ) : (
              <></>
            )}
          </div>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormControl style={{ margin: '5px' }}>
                <InputLabel id="demo-simple-select-label">Graph</InputLabel>
                <Select
                  // style={{width: '100px', height: '20px'}}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={graphNumber}
                  label="Graph"
                  onChange={(e) => {
                    setGraphNumber(e.target.value);
                  }}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl>
                <TextField
                  style={{ width: '100px' }}
                  type="number"
                  label="Speed:"
                  variant="standard"
                  onChange={(e) => {
                    let value;
                    const prevValue = speedSec[graphNumber];
                    const newValue = parseFloat(e.target.value);
                    const typeIter = newValue > prevValue ? 'inc' : 'dec';
                    if (newValue <= 1) {
                      // Inc or Dec by 0.1
                      if (typeIter === 'dec') {
                        value = Math.round((prevValue - 0.1) * 10) / 10;
                      } else {
                        value = Math.round((prevValue + 0.1) * 10) / 10;
                      }
                    } else {
                      // Inc or Dec by 1
                      if (typeIter === 'dec') {
                        value = Math.round(prevValue - 1);
                      } else {
                        value = Math.round(prevValue + 1);
                      }
                    }

                    const newSpeedSec = { ...speedSec };
                    newSpeedSec[graphNumber] = Number(value);
                    localStorage.setItem(
                      'speedSecEu',
                      JSON.stringify(newSpeedSec)
                    );
                    setSpeedSec(newSpeedSec);
                  }}
                  value={speedSec[graphNumber]}
                  InputProps={{
                    inputProps: { min: 0.1, step: 0.1 },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enableRot}
                      onClick={() => setEnableRot(!enableRot)}
                    />
                  }
                  label="Rotate"
                />
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Europe;
